import checkin from "./checkin"
import accidentreport from "./accidentreport"
import evaluation from "./evaluation"
import docket from "./docket"

export default {
  checkin,
  accidentreport,
  evaluation,
  docket
}
